import { combineReducers } from "redux";
import * as types from "../../../_constants/types";

const fetch = (state = { loading: false }, action) => {
    switch (action.type) {
        case types.CANCEL_ORDER_CALCULATING:
            return { loading: true };

        case types.CANCEL_ORDER_CALCULATING_COMPLETED:
            return { loading: false };

        case types.CANCEL_ORDER_CALCULATING_FAILED:
            return { loading: false, err: action.err };

        default:
            return state;
    }
};

const data = (state = {}, action) => {
    switch (action.type) {
        case types.CANCEL_ORDER_CALCULATE_LOAD:
            return JSON.parse(JSON.stringify(action.data));

        case types.RESET:
        case types.CANCEL_ORDER_CALCULATE_RESET:
            return {};

        default:
            return state;
    }
};

export default combineReducers({ data, fetch });
